/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:09
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('SaleCureView',["$sce","SaleCureData","SaleCure","$filter","CureItemView","CureItem","CureItemData","CurrencyManager","NumberSeparatorType",
        function ($sce,SaleCureData,SaleCure,$filter,CureItemView,CureItem,CureItemData,CurrencyManager,NumberSeparatorType)
        {

        var SaleCureView = function (saleCure,scIndex,billPosition,saleView)
        {
            this.scIndex = scIndex; //model index
            this.posView = (saleView ? saleView.posView : null);
            this.saleView = saleView;
            this.cureView = null;
            this.label = "";
            this.price = 0;
            this.priceHT=0;
            this.vat= null;
            this.vatCode = null;
            this.originalPrice = 0;
            this.originalPriceInput = "";
            this.discountPercent = 0;
            this.quantity= 0;
            this.quantityInput= 0;//input value binded
            this.hrView;
            this.billPosition =billPosition;//position inside sale ->
            this.cureItemsView = [];
            if (saleCure)
                this.loadDataFrom(saleCure);

        }
        SaleCureView.prototype.getModel = function()
        {
            if (this.scIndex!=-1)
            {
                return SaleCureData.getByIndex(this.scIndex);
            }
            return null;
        }
        SaleCureView.prototype.loadDataFrom = function(saleCure)
        {
            //Assume here than the object in parameter contains only id (must load them)
            if (saleCure)
            {
                if (saleCure.cure && this.posView && this.posView.domainView)
                    this.cureView =  this.posView.domainView.getCureView(saleCure.cure);
                this.label = saleCure.label;
                this.price= saleCure.price;
                if (saleCure.vatCode)
                {
                    this.vat= saleCure.vat;
                    this.vatCode= saleCure.vatCode;
                }
                else
                {
                    if (this.saleView)
                    {
                        this.vat = this.saleView.vat;
                        this.vatCode = this.saleView.vatCode;
                    }
                }
                this.updatePriceHT();
                if (saleCure.originalPrice!=null)
                    this.originalPrice = saleCure.originalPrice;
                else
                    this.originalPrice = this.price;
                this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
                this.discountPercent = saleCure.discountPercent;
                this.quantity= saleCure.quantity;
                this.quantityInput= saleCure.quantity;
                if (saleCure.humanResource && this.posView && this.posView.domainView)
                    this.hrView = this.posView.domainView.getHrView(saleCure.humanResource);

                this.loadCureItems(saleCure);
            }
        };
        SaleCureView.prototype.loadCureItems = function(saleCure)
        {
            this.cureItemsView = [];
            if (saleCure && saleCure.cureItems && this.posView)
                for (var i=0;i<saleCure.cureItems.length;i++)
                    this.cureItemsView.push(new CureItemView(saleCure.cureItems[i],CureItemData.getIndexOf(saleCure.cureItems[i]),this,this.posView.domainView));
        };

        SaleCureView.prototype.copyDataTo = function(saleCure)
        {
            if (saleCure)
            {
                saleCure.label = this.label;
                if (this.cureView)
                    saleCure.cure = this.cureView.getModel();
                saleCure.price= this.price;
                saleCure.vat = this.vat;
                saleCure.vatCode= this.vatCode;
                saleCure.originalPrice= this.originalPrice;
                if (this.discountPercent && typeof this.discountPercent ==='string')
                {
                    saleCure.discountPercent = this.discountPercent.replace(",",".").replace(" ","");
                    saleCure.discountPercent = parseFloat(saleCure.discountPercent);
                }
                else
                    saleCure.discountPercent= this.discountPercent;
                saleCure.quantity= this.quantity;

                var newSale = this.saleView.getModel();
                if (saleCure.sale && newSale!==saleCure.sale)//remove
                    saleCure.sale.removeSaleCure(saleCure);
                if (newSale)//Force add because removed by sale.updateModel
                    newSale.addSaleCure(saleCure);
                if (this.hrView)
                    saleCure.humanResource = this.hrView.getModel();

                if (saleCure.cureItems)
                {
                    var oldCureitems = saleCure.cureItems;
                    saleCure.cureItems = [];
                    var cureItem = null;
                    for (var i=0;i<this.cureItemsView.length;i++)
                    {
                        if (i<oldCureitems.length)//copy exising
                            cureItem = oldCureitems[i];
                        else
                            cureItem = new CureItem(null,saleCure);

                        this.cureItemsView[i].copyDataTo(cureItem);
                        saleCure.addCureItem(cureItem);

                    }
                }
            }
        }

        SaleCureView.prototype.getClone = function(saleView)
        {
            var spView = new SaleCureView(null,-1,this.billPosition,saleView);
            spView.vatCode= this.vatCode;
            spView.vat= this.vat;
            spView.label = this.label;
            spView.cureView = this.cureView;
            spView.price= this.price;
            spView.originalPrice= this.originalPrice;
            spView.originalPriceInput= this.originalPriceInput;
            spView.discountPercent= this.discountPercent;
            spView.quantity= this.quantity;
            spView.quantityInput= this.quantityInput;
            spView.hrView = this.hrView;
            spView.updateCureItems();
            return spView;
        };
        SaleCureView.prototype.selectCure = function () {
            if (this.cureView)
                this.cureView.isSelected = true;
        }

        SaleCureView.prototype.updateOriginalPriceInputArrow = function(number)
        {
            if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput!=null && typeof this.originalPriceInput ==='string') {
                var originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                var originalPrice = parseFloat(originalPriceStr);
                if(originalPrice !== "NaN")
                    originalPrice+= number;

                this.originalPriceInput = $filter('currencyFormatFilter')(originalPrice);
                this.originalPrice = originalPrice;
                this.updatePrice();
            }
        }

        SaleCureView.prototype.onOriginalPriceInputChange = function () {
            if (this.saleView && !this.saleView.isReadOnly && this.originalPriceInput != null && typeof this.originalPriceInput === 'string') {
                let originalPriceStr = CurrencyManager.getPriceFromPriceInput(this.originalPriceInput);
                let originalPrice = parseFloat(originalPriceStr);
                if (originalPrice !== "NaN") {
                    this.originalPrice = originalPrice;
                } else {
                    this.originalPrice = null;
                }
                this.updatePrice();
            }
        }

        SaleCureView.prototype.setCure = function(cureView,isOnInternet)
        {
            this.cureView = cureView;
            if (cureView!=null)
            {
                if(this.posView && this.posView.domainView)
                {
                    var vatView = this.posView.domainView.getDefaultVatView();
                    if (vatView) {
                        this.vat = vatView.tax;
                        this.vatCode = vatView.code;
                    }
                }
                this.label = cureView.label;
                this.originalPrice = cureView.price;
                this.originalPriceInput = $filter('currencyFormatFilter')(this.originalPrice);
                this.quantity++;
                this.quantityInput++;
                if (isOnInternet!==undefined && isOnInternet && cureView.hasInternetPrice)
                    this.discountPercent = cureView.internetDiscountPercent;
                this.updatePrice();
                var cureItemView = new CureItemView();
                this.cureItemsView.push(cureItemView);
                cureItemView.init(this);

            }
        };
        SaleCureView.prototype.hasCureItemUsage = function()
        {
            var hasUsage = false;
            for (var i=0;i<this.cureItemsView.length&&!hasUsage;i++)
                hasUsage = this.cureItemsView[i].hasCureItemUsage();
            return hasUsage;
        };
        SaleCureView.prototype.setHrView = function(hrView)
        {
           this.hrView = hrView;
        };
        SaleCureView.prototype.updatePriceHT = function(){
            this.priceHT = Math.round((100/(100+this.saleView.vat) * this.price)*100)/100;
        };
        SaleCureView.prototype.onChangeQuantity = function()
        {
            if (this.cureView!=null)
            {
                if (this.quantityInput <= 0) {
                    this.quantityInput = 1;
                }
                this.quantity = this.quantityInput;
                this.updatePrice();
                this.updateCureItems();
            }
        }
        SaleCureView.prototype.updateCureItems = function()
        {
            var oldCureitemsView = this.cureItemsView;
            this.cureItemsView = [];
            var cureItemView = null;
            for (var i=0;i<this.quantity;i++)
            {
                if (i<oldCureitemsView.length)
                    this.cureItemsView.push(oldCureitemsView[i]);
                else
                {
                    cureItemView = new CureItemView();
                    this.cureItemsView.push(cureItemView);
                    cureItemView.init(this);
                }
            }
        }
        SaleCureView.prototype.increaseDiscountPercent = function(step) {
            if (this.saleView && !this.saleView.isReadOnly) {
                if ((step+this.discountPercent)>100)
                    this.discountPercent = 100;
                else
                    this.discountPercent+=step;
                this.updatePrice();
            }

        }
        SaleCureView.prototype.decreaseDiscountPercent = function(step) {
            if (this.saleView && !this.saleView.isReadOnly) {
                if (this.discountPercent-step<0)
                    this.discountPercent = 0;
                else
                    this.discountPercent-=step;
                this.updatePrice();
            }

        };

        SaleCureView.prototype.updatePrice = function()
        {
            var oriPrice = this.originalPrice*this.quantity;
            var discount = 0;
            var discountPercent =this.discountPercent;
            if (this.discountPercent && typeof this.discountPercent ==='string')
            {
                discountPercent = this.discountPercent.replace(",",".").replace(" ","");
                discountPercent = parseFloat(discountPercent);
            }
            if (discountPercent!=0)
                discount = Math.round((discountPercent *  oriPrice / 100)*100)/100;

            if ((oriPrice-discount)!=this.price)
            {
                this.price = (oriPrice-discount);
                this.updatePriceHT();
                this.saleView.resetPayments();
                this.saleView.calculateSaleFields();
            }
            this.saleView.checkForInvalidAmounts();
        }
        SaleCureView.prototype.updateModel = function()
        {
            var saleCure = this.getModel();
            if (saleCure==null)
            {
                saleCure = new SaleCure();
                this.scIndex = SaleCureData.getIndexOf(saleCure);
            }
            this.copyDataTo(saleCure);


        }


        SaleCureView.prototype.removeModel = function()
        {
        }
        SaleCureView.prototype.reloadModel = function()
        {
            var saleCure = this.getModel();
            if (saleCure==null)
            {
                //this.parentCategoryView.removeSaleCureView(this);
            }
            else
            {
                this.loadDataFrom(saleCure);
            }
        }


        SaleCureView.prototype.canSave = function()
        {
            if (!this.cureView)
                return false;
            var quantityInt = parseInt(this.quantity);
            if(quantityInt !== "NaN" && quantityInt !== "")
            {
                this.quantity = quantityInt;
            }
            else
            {
                this.quantity = null;
            }
            var priceFloat = parseFloat(this.price);
            if(priceFloat !== "NaN" && priceFloat !== "")
            {
                this.price = priceFloat;
            }
            else
            {
                this.price = "";
            }

            if
            (
                (this.label && this.label!="") //titre
                && (this.price && this.price>=0) //prix (décimal)
                && (this.quantity!=null && this.quantity>0) //durée (entier)
            )
            { return true; }
            else
            { return false; }
        }

        return SaleCureView;
    }
    ]);



// WEBPACK FOOTER //
// ./js/services/views/SaleCureView.js